/**
 * ClinicBlock — мобильная карточка тарифа клиники: шапка + пакеты списком
 * (бейдж «Хит» у популярного) + строка гибридной ступени «Сеть».
 */

import {Building2} from 'lucide-react';

import type {ClinicPackage} from '@services/clients';
import type {ClinicTariff} from '@services/tariffs';
import {formatNumber} from '@utils/format';

import {CardHead} from '../CardHead';

type ClinicBlockProps = {
  clinic: ClinicTariff;
  onEdit: () => void;
};

export const ClinicBlock = ({clinic, onEdit}: ClinicBlockProps) => {
  const last = clinic.packages[clinic.packages.length - 1];
  return (
    <div className="rounded-[15px] border border-skr-line bg-card px-[17px] py-4">
      <CardHead
        icon={<Building2 className="size-5" strokeWidth={1.7} />}
        iconClassName="bg-skr-icon-bg text-muted-foreground"
        title="Клиника"
        subtitle={`пакеты · админ бесплатно · ${clinic.version === 0 ? 'не задан' : `v${clinic.version}`}`}
        onEdit={onEdit}
      />
      <div className="mt-3.5 flex flex-col gap-[9px]">
        {clinic.packages.map((p, i) => (
          <PackageRow
            key={p.name + i}
            pkg={p}
            lo={i === 0 ? 1 : clinic.packages[i - 1].upTo + 1}
            popular={i === 1}
          />
        ))}
        <div className="flex items-center gap-2.5 rounded-[11px] border border-skr-line2 bg-skr-head px-[13px] py-[11px]">
          <div className="flex-1">
            <div className="text-sm font-bold">Сеть</div>
            <div className="mt-px text-[11.5px] text-skr-label">
              11+ · {formatNumber(last.price)} + за место сверх {last.upTo}
            </div>
          </div>
          <div className="text-right">
            <span className="font-mono text-[15px] font-semibold">
              +{formatNumber(clinic.overPrice)}
            </span>{' '}
            <span className="text-[11px] text-muted-foreground">/место</span>
          </div>
        </div>
      </div>
    </div>
  );
};

const PackageRow = ({pkg, lo, popular}: {pkg: ClinicPackage; lo: number; popular: boolean}) => (
  <div className="flex items-center gap-2.5 rounded-xl border-[1.5px] border-skr-line2 bg-card px-[13px] py-3">
    <div className="flex-1">
      <div className="flex items-center gap-2">
        <span className="text-[14.5px] font-bold">{pkg.name}</span>
        {popular && (
          <span className="rounded-full bg-primary px-[7px] py-0.5 text-[9.5px] font-semibold uppercase tracking-[.04em] text-primary-foreground">
            Хит
          </span>
        )}
      </div>
      <div className="mt-px text-[11.5px] text-skr-label">
        {lo}–{pkg.upTo} врача
      </div>
    </div>
    <div className="text-right">
      <span className="font-mono text-[17px] font-semibold">{formatNumber(pkg.price)}</span>{' '}
      <span className="text-[11px] text-muted-foreground">сом</span>
    </div>
  </div>
);
